import { graphql } from '@/generated/gql';

export const SOURCING_CASE_INTERNAL_FILE_ATTACHMENTS_QUERY = graphql(/* GraphQL */ `
  query SourcingCaseInternalFileAttachments(
    $parents: [TsrctAttachmentParentInput!]!
    $filter: TsrctAttachmentFilterInput
  ) {
    tesseract {
      attachments(parents: $parents, filter: $filter) {
        ...FileAttachment
      }
    }
  }
`);

export const SOURCING_CASE_INTERNAL_FILE_ATTACHMENTS_CASE_AND_DEMAND_QUERY = graphql(/* GraphQL */ `
  query SourcingCaseInternalFileAttachmentsCaseAndDemand($sourcingCaseId: UUID!) {
    tesseract {
      sourcingCase(id: $sourcingCaseId) {
        id
        status
        demand {
          id
        }
      }
    }
  }
`);
